// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#343744","menuText":"#bfcbd9","menuActiveText":"#4da3ff"};